var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3437_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 16C18.8125 17.5532 17.5532 18.8125 16 18.8125C14.4468 18.8125 13.1875 17.5532 13.1875 16C13.1875 14.4468 14.4468 13.1875 16 13.1875C17.5532 13.1875 18.8125 14.4468 18.8125 16Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 7.5H11.25C9.18213 7.5 7.5 9.18213 7.5 11.25V20.75C7.5 22.8179 9.18213 24.5 11.25 24.5H20.75C22.8179 24.5 24.5 22.8179 24.5 20.75V11.25C24.5 9.18213 22.8179 7.5 20.75 7.5ZM16 20.6875C13.4153 20.6875 11.3125 18.5847 11.3125 16C11.3125 13.4153 13.4153 11.3125 16 11.3125C18.5847 11.3125 20.6875 13.4153 20.6875 16C20.6875 18.5847 18.5847 20.6875 16 20.6875ZM21.375 11.5625C20.8572 11.5625 20.4375 11.1428 20.4375 10.625C20.4375 10.1072 20.8572 9.6875 21.375 9.6875C21.8928 9.6875 22.3125 10.1072 22.3125 10.625C22.3125 11.1428 21.8928 11.5625 21.375 11.5625Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 0H8.4375C3.78516 0 0 3.78516 0 8.4375V23.5625C0 28.2148 3.78516 32 8.4375 32H23.5625C28.2148 32 32 28.2148 32 23.5625V8.4375C32 3.78516 28.2148 0 23.5625 0ZM26.375 20.75C26.375 23.8516 23.8516 26.375 20.75 26.375H11.25C8.14844 26.375 5.625 23.8516 5.625 20.75V11.25C5.625 8.14844 8.14844 5.625 11.25 5.625H20.75C23.8516 5.625 26.375 8.14844 26.375 11.25V20.75Z",
    fill: "#20ACE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3437_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.13337239e6d47b4859ebf9fa467de6ef.svg";
export { ForwardRef as ReactComponent };